import React from "react";
import { Images } from "./assets";
import { Col, Container, Row } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "./redux/store";
import { userSliceSelectors } from "./redux/user/user.selector";
import { userActions } from "./redux/user/user.slice";
import { AtiraToast } from "./utils/AtiraToast";
import { useNavigate } from "react-router-dom";

export const Header: React.FC = () => {
  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId);

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const isLoggedIn = Boolean(userId?.length);

  const logout = async () => {
    try {
      dispatch(userActions.logout());

      const token = process.env.REACT_APP_LOCAL_STORAGE_TOKEN_KEY;

      if (token?.length) {
        localStorage.removeItem(token);
      }

      navigate("/login", { replace: true });
    } catch (e) {
      console.log(e);
      AtiraToast.apiError(e);
    }
  };

  return (
    <header className="header py-3 px-2 px-md-4">
      <Container fluid>
        <Row className="align-items-center flex-row-reverse">
          <Col xs={3} className="d-none d-md-block"></Col>

          <Col xs={isLoggedIn ? 6 : 24}>
            <div className="logo m-auto">
              <img
                src={Images.HorizontalLogo}
                className="w-100"
                alt="company-logo"
              />
            </div>
          </Col>

          <Col xs={6} md={3}>
            {isLoggedIn ? (
              <button
                onClick={logout}
                className="btn btn-danger py-2 px-4 ms-auto"
              >
                Logout
              </button>
            ) : null}
          </Col>
        </Row>
      </Container>
    </header>
  );
};
